import { createFeatureSelector } from '@ngrx/store';

export const getAuthState = createFeatureSelector('app-auth');
